import { isString } from "lodash"
import type React from "react"
import { Navigate, useSearchParams } from "react-router-dom"
import { setAuthToken } from "~/modules/authentication/util"
import { trpc } from "~/utils/trpc"

export const LoginConfirm: React.FC = () => {
  // Try and get "token" parameter from URL
  const [search] = useSearchParams()

  const token = search.get("token") ?? ""
  setAuthToken(token)

  const { data: user, isLoading } = trpc.users.me.useQuery(void 0, {
    enabled: !!token,
  })

  if (!token || !isString(token)) {
    return <div>Lenken er utgått eller ugyldig</div>
  }

  if (isLoading) {
    return <div>Laster...</div>
  }

  if (token && !user) {
    return <div>Lenken er utgått eller ugyldig</div>
  }

  return <Navigate to={"/"} />
}
